import axios from "@/api/axios";

const clientCalls = (data) => {
    return axios
        .post('/admin/calls', {clientCalls: data})
        .then(response => response.data)
}

export default {
    clientCalls,
}